import ApiService from 'utils/ApiCalls';
import {
  LanguageList,
  ICategoryResponse,
  ICategoryOption
} from 'store/ducks/globalTypes';

let cachedCategories: ICategoryOption[] = [];

// Initialize categories on module load
let initialized = false;
let initPromise: Promise<ICategoryOption[]> | null = null;

export const fetchCategories = async (lang: LanguageList = LanguageList.EN) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('user') || '{}')?.token;
    if (!token) {
      return [];
    }

    const response = await ApiService.getCategory(lang, {});

    if (response.data && Array.isArray(response.data)) {
      cachedCategories = response.data.map((category: ICategoryResponse) => ({
        label:
          category.description ||
          category.short_name ||
          category.name ||
          String(category),
        value: category.id
      }));
    } else if (response.data) {
      const categories = Object.values(response.data) as ICategoryResponse[];
      if (Array.isArray(categories)) {
        cachedCategories = categories.map((category) => ({
          label:
            category.description ||
            category.short_name ||
            category.name ||
            String(category),
          value: category.id
        }));
      }
    } else {
      cachedCategories = [];
    }

    return cachedCategories;
  } catch (error) {
    console.error('Failed to fetch categories:', error);
    return [];
  }
};

// For components to use
export const getDynamicCategories = async (
  lang: LanguageList = LanguageList.EN
) => {
  if (cachedCategories.length > 0) {
    return cachedCategories;
  }

  if (initPromise) {
    try {
      await initPromise;
      if (cachedCategories.length > 0) {
        return cachedCategories;
      }
    } catch (error) {
      console.error('Initialization failed, trying fresh fetch:', error);
    }
  }

  const categories = await fetchCategories(lang);
  return categories;
};

const initializeCategories = async () => {
  if (!initialized && !initPromise) {
    initPromise = fetchCategories();
    try {
      await initPromise;
      initialized = true;
    } catch (error) {
      console.error('Category initialization failed:', error);
      initPromise = null;
    }
  }
  return initPromise;
};

// Auto-initialization removed - will initialize when needed after login

// Export dynamic categories as default
const getCategoryList = () => cachedCategories;

// Provide a synchronous fallback for components that need immediate data
export const getCategoriesSync = () => {
  if (cachedCategories.length === 0) {
    getDynamicCategories().catch(console.error);
  }
  return cachedCategories;
};

export default getCategoryList;
